/**
 * Booking Engine Logic Module
 *
 * Proxy exports for all booking engine utilities
 */

// Search parameters
export {
  build_search_params,
  build_search_request,
  build_keydmap_request,
  encode_search_params,
} from './search-params';

// Placeholders
export {
  get_occupancy_placeholder,
  get_autocomplete_placeholder,
  get_airports_placeholder,
  get_availabilities_placeholder,
} from './placeholders';

// API
export {
  get_keyds,
  get_airports_api,
  get_availabilities_api,
} from './api';

// Package type tabs
export {
  get_configured_package_type,
  resolve_initial_package_type,
} from './package-type-tabs';

// Navigation & Date helpers
export {
  date_check,
  formatDateDisplay,
  calculateMinCheckinDate,
  calculateMaxDate,
} from './navigation';
